import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/guide")({
  component: Outlet,
});
